import {
  AlignError,
  NoFieldPlansError,
  TimeoutError
} from "./utils/territoryFeedbackErrors.js";

export default class TerritoryFeedbackService {
  static FEEDBACK_PATH = "/align/feedback";
  static POST_REQUEST_TIMEOUT_MS = 60000;

  constructor(alignServer) {
    this._alignServer = alignServer;
  }

  async login(userId, headers) {
    const url = userId ? `/login?crmUserId=${userId}` : `/login`;
    return headers ? this.getRequest(url, headers) : this.getRequest(url);
  }

  async getTerritoryModelDetails(territoryModelId, headers) {
    const url = `/territory/${territoryModelId}`;
    return headers ? this.getRequest(url, headers) : this.getRequest(url);
  }

  get feedbackApiPathString() {
    const feedbackServer = convertToRedesignedFeedbackURL(this._alignServer);
    return `https://${feedbackServer}${TerritoryFeedbackService.FEEDBACK_PATH}`;
  }

  async getRequest(urlPath, customOptions) {
    const url = new URL(`${this.feedbackApiPathString}${urlPath}`);

    const options = customOptions ? customOptions : { credentials: "include" };
    const response = await timeoutPromise(
      TerritoryFeedbackService.POST_REQUEST_TIMEOUT_MS,
      fetch(url, options)
    );

    if (!response.ok) {
      if (response.status === 400) {
        const errorBody = await response.json();
        throw new NoFieldPlansError(errorBody.message);
      } else {
        const isUnauthorizedError = response.status === 401;
        throw new AlignError(response.statusText, isUnauthorizedError);
      }
    }

    return response.json();
  }
}

function timeoutPromise(ms, promise) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new TimeoutError("Request to Align timed out"));
    }, ms);

    promise.then(
      res => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      err => {
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  });
}

function convertToRedesignedFeedbackURL(alignServer) {
  return alignServer.replace("-app.", "-feedback.");
}
